// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"b191bf08","293":"d4e5ab32","556":"4daed8bc","630":"5ba2998a","705":"a4a2e860","815":"e479c14f"}[chunkId] + ".chunk.js";
};